export default __webpack_public_path__ + "static/media/00.7d9451ca.jpg";